import { createStore } from 'vuex'

export default createStore({
    state() {
        return {
            profileForm: {},
            suitabilityForm: {},
            investForm: {},
            verificationForm: {},
            agreementForm: {},
            notificationForm: {},
            envelopeId: ''
        }
    },
    mutations: {
        UPDATE_FORM_DATA(state, payload){
            state[payload.form] = payload.data
        },
        UPDATE_FORM_ENVELOPE(state, payload){
            state.envelopeId = payload
        },
        UPDATE_NORTH_DATA(state, payload){
            state.northData[payload.key] = payload.value
        }
    },
    actions: {
        updateFormData(state, payload){
            state.commit('UPDATE_FORM_DATA', payload)
        },
        updateFormEnvelope(state, payload){
            state.commit('UPDATE_FORM_ENVELOPE', payload)
        },
        updateNorthData(state, payload){
            state.commit('UPDATE_NORTH_DATA', payload)
        }
    }
})
